module.exports = __webpack_public_path__ + "static/media/icono_cerrar.96481920.svg";